<template>
    <div class="register-dialog">
        <el-dialog :visible.sync="isOpenRegisterDialog"
                   :before-close="handleClose"
                   :close-on-click-modal="false"
                    class="smaller-width-xxs">
            <div class="login-sso-notice" v-if="showEmail">
                <p class="login-sso-notice__title">
                    <i class="el-icon-info login-sso-notice__icon" aria-hidden="true"></i>
                    AIユイゴン&nbsp;Well-Bをご利用の方へ
                </p>
                <p class="login-sso-notice__text">
                    AIユイゴン&nbsp;Well-Bにご登録済の方は、新規登録は不要です。<br>ログイン画面からAIユイゴン&nbsp;Well-BのID/パスワードでログインしてください。
                </p>
            </div>
            <el-row v-if="showEmail">
                <el-col align="left" style="font-size: 16px" class="xxs-font-size-13"><p v-html="title"></p></el-col>
            </el-row>
            <el-row v-if="showEmail">
                <el-col align="left" style="font-size: 16px" class="xxs-font-size-13"><p v-html="titleEmail"></p></el-col>
                <br>
                <el-input class="w-100" v-model="emailOrPhone" style="width: 60%" autofocus="true"></el-input>
                <el-col align="left" style="font-size: 12px; color: #f56c6c; font-weight: bold;">{{msgError}}</el-col>
            </el-row>
            <el-row v-if="!showEmail">
                <el-col align="left" style="font-size: 16px" class="xxs-font-size-13"><p v-html="msgSuccess"></p></el-col>
            </el-row>
            <el-row class="btn-register-dialog" v-if="showEmail">
                <el-button @click="handleClose">キャンセル</el-button>
                <el-button @click="confirmEmail">確認メールを送信</el-button>
            </el-row>
            <el-row class="btn-register-dialog" v-else>
                <el-button @click="handleClose">閉じる</el-button>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SET_OPEN_REGISTER_DIALOG } from '@/store/actions.type'
import MailApi from '@/api/mail'
export default {
    data () {
        return {
           title: '会員登録を行うメールアドレスか携帯電話の電話番号を入力してください。<br/>入力後「確認メールを送信」をクリックすると登録用のURLが入力頂いたメールアドレス又は携帯電話に送信されますので受信しましたら、本文内に記載されているURLにアクセス頂き、会員登録をお願い致します。',
           titleEmail: '以下に登録するメールアドレス又は携帯電話番号を半角で入力してください。携帯電話番号はハイフンを含めて入力してください。',
           emailOrPhone: '',
           showEmail: true,
           msgError: ''
        }
    },
    computed: {
        ...mapGetters(['isOpenRegisterDialog'])
    },
    methods: {
        handleClose () {
            this.$store.dispatch(SET_OPEN_REGISTER_DIALOG, false)
            this.resetForm()
        },
        async confirmEmail () {
            if (!this.emailOrPhone) {
                this.msgError = 'メールアドレス又は携帯電話番号（ハイフンあり）が未入力です'
                return
            }

            const reMail = /^\S+@\S+\.\S+$/
            const reMobilePhone = /^\d{3}-\d{4}-\d{4}$/
            if (!reMail.test(this.emailOrPhone) && !reMobilePhone.test(this.emailOrPhone)) {
              this.msgError = 'メールアドレス又は携帯電話番号（ハイフンあり）を入力してください'
              return
            }

            const api = reMobilePhone.test(this.emailOrPhone) ? MailApi.sendMemberRegistrationMailWeb : MailApi.sendMemberRegistrationMailWeb
            await api(this.emailOrPhone)
            this.msgError = ''
            this.showEmail = false
            this.msgSuccess = '以下に確認メールを送信しました。メールに記載されたURLをクリックしていただき、会員情報入力画面から会員登録をお願いいたします。' +
                                '<br/> ' + this.emailOrPhone +
                                '<br/>※7日以内にお手続きください。' +
                                '<br/>※1時間たっても受信しない場合はメールアドレスか携帯電話の番号が間違っている可能性がありますので、お手数ですが、再度「無料登録」を行ってください。'
        },
        resetForm () {
            this.emailOrPhone = ''
            this.showEmail = true
            this.msgError = ''
            this.msgSuccess = ''
        }
    }
}
</script>
<style>
.register-dialog .el-row{
    padding-bottom: 30px;
}
.register-dialog .btn-register-dialog {
    text-align: center;
}
  .register-dialog .el-dialog {
    width: 40%;
    min-width: 320px;
  }
</style>
<style scoped>
/* Same look as the AIユイゴン Well-B notice in Login.vue/ForgotPassword.vue (login.css, scoped there). */
.login-sso-notice {
    background: #eef7fb;
    border: 1px solid #9ccde0;
    border-left: 4px solid #009cad;
    border-radius: 4px;
    margin-bottom: 1.25em;
    padding: 0.85em 1em;
}
.login-sso-notice__title {
    display: flex;
    align-items: center;
    gap: 0.35em;
    margin: 0 0 0.4em;
    color: #007a8a;
    font-size: 15px;
    font-weight: bold;
    line-height: 1.4;
}
.login-sso-notice__icon {
    font-size: 18px;
}
.login-sso-notice__text {
    margin: 0;
    color: #333;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.6;
}
</style>
